import { render } from "./containerImpact.vue?vue&type=template&id=c88638ba&scoped=true"
import script from "./containerImpact.vue?vue&type=script&lang=js"
export * from "./containerImpact.vue?vue&type=script&lang=js"

import "./containerImpact.vue?vue&type=style&index=0&id=c88638ba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c88638ba"]])

export default __exports__